import { render, staticRenderFns } from "./MakeFormList.vue?vue&type=template&id=3941172e"
import script from "./MakeFormList.vue?vue&type=script&lang=js"
export * from "./MakeFormList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3941172e')) {
      api.createRecord('3941172e', component.options)
    } else {
      api.reload('3941172e', component.options)
    }
    module.hot.accept("./MakeFormList.vue?vue&type=template&id=3941172e", function () {
      api.rerender('3941172e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/form/MakeFormList.vue"
export default component.exports